import type { BetSlipState } from '../types';
import type { ReduxState } from 'app/redux/types';

import type { BigStakesState } from '../types/bigStakes';
import type { ConflictState } from '../types/conflict';
import type { RecordOfEntriesState } from '../types/entries';
import type { OneClickBetState } from '../types/oneClickBet';
import { PreferencesState } from '../types/preferences';
import type { RecordOfStakeTypesState } from '../types/stakeTypes';
import type { RecordOfExpressStakeType } from '../types/stakeTypes/express';
import type { RecordOfSingleStakeType } from '../types/stakeTypes/singles';
import type { RecordOfSystemStakeTypeState } from '../types/stakeTypes/system';
import { SubmissionState } from '../types/submission';
import type { WaitingInQueueState } from '../types/waitingInQueue';

// ---

export const selectBetSlipState = (state: ReduxState): BetSlipState => {
  return state.betSlip;
};

export const selectOneClickBetState = (state: ReduxState): OneClickBetState => {
  return selectBetSlipState(state).oneClickBet;
};

export const selectPreferencesState = (state: ReduxState): PreferencesState => {
  return selectBetSlipState(state).preferences;
};

export const selectStakeTypesState = (state: ReduxState): RecordOfStakeTypesState => {
  return selectBetSlipState(state).stakeTypes;
};

export const selectSubmissionState = (state: ReduxState): SubmissionState => {
  return selectBetSlipState(state).submission;
};

export const selectBigStakesState = (state: ReduxState): BigStakesState => {
  return selectBetSlipState(state).bigStakes;
};

export const selectWaitingInQueueState = (state: ReduxState): WaitingInQueueState => {
  return selectBetSlipState(state).waitingInQueue;
};

export const selectEntriesState = (state: ReduxState): RecordOfEntriesState => {
  return selectBetSlipState(state).entries;
};

export const selectSingleStakeTypeState = (state: ReduxState): RecordOfSingleStakeType => {
  return selectBetSlipState(state).stakeTypes.single;
};

export const selectExpressStakeTypeState = (state: ReduxState): RecordOfExpressStakeType => {
  return selectBetSlipState(state).stakeTypes.express;
};

export const selectSystemStakeTypeState = (state: ReduxState): RecordOfSystemStakeTypeState => {
  return selectBetSlipState(state).stakeTypes.system;
};

export const selectConflictState = (state: ReduxState): ConflictState => {
  return selectBetSlipState(state)?.conflict;
};
